import { useSelector } from 'react-redux';
import { selectIsMobileLayout } from '../../../../../selectors/layout';
import { selectExperiments } from '../../../../../selectors/experiments';
import { allExperiments, servicesCardsTextsExperimentName } from '../../../../../constants/experiments';

interface IUseToggleLabel {
  showLabel: boolean;
}

export const useToggleLabel = (): IUseToggleLabel => {
  const isMobile = useSelector(selectIsMobileLayout);
  const activeExperiments = useSelector(selectExperiments);
  const textsExperimentGroups = allExperiments[servicesCardsTextsExperimentName];
  const textsExperimentGroup = activeExperiments[servicesCardsTextsExperimentName] || textsExperimentGroups!.default;

  const slowLabelGroups =
    textsExperimentGroup === textsExperimentGroups!.redesign || textsExperimentGroup === textsExperimentGroups!.default;

  const showLabel = !isMobile && slowLabelGroups;

  return {
    showLabel,
  };
};
